import i18n from '@/i18n'
import { pickBy } from '@/utils'

export default {
  name: 'headline',
  setting: [
    { label: i18n.t('wgt_headline.config.463137-0'), key: 'title', component: 'input', value: i18n.t('wgt_headline.config.463137-0') },
    {
      label: i18n.t('wgt_headline.config.463137-1'),
      key: 'float',
      component: 'radio',
      options: [
        { name: i18n.t('wgt_headline.config.463137-2'), label: 'left' },
        { name: i18n.t('wgt_headline.config.463137-3'), label: 'center' }
      ],
      value: 'center'
    }
  ],
  transformIn: (v) => {
    const { name, base } = v
    return {
      name,
      ...base
    }
  },
  transformOut: (v) => {
    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
          title: 'title',
          float: 'float'
        })
      }
    })
  }
}
